const EmptyDiv = () => <div style={{ width: '0.1px' }}></div>;

export default EmptyDiv;
